module.exports = __webpack_public_path__ + "img/Frame-33.cc1d9a99.svg";